import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessModeSettings, UpdateBusinessModeSettingsRequest } from "@/shared/types/api/business-mode.types"

export const updateBusinessSettingsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessConnectionSettings"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      updateBusinessSettings: builder.mutation<BusinessModeSettings, UpdateBusinessModeSettingsRequest>({
        query: body => ({
          url: "/api/v1/business/connections/settings",
          method: "PATCH",
          body
        }),
        invalidatesTags: () => [{ type: "BusinessConnectionSettings" as const }]
      })
    })
  })

export const { useUpdateBusinessSettingsMutation } = updateBusinessSettingsApi
